import * as OIDClient from "openid-client";

export async function prepare({ server, clientId }) {
  const config = await OIDClient.discovery(new URL(server), clientId);
  const { authorization_endpoint } = config.serverMetadata();

  return {
    authorizationUrl: authorization_endpoint.toString(),
    clientId,
  };
}

export async function login(env, { nonce, redirectUri }) {
  const { authorizationUrl, clientId } = await env;

  const url = new URL(authorizationUrl);
  url.searchParams.append("response_type", "id_token");
  url.searchParams.append("client_id", clientId);
  url.searchParams.append("redirect_uri", redirectUri);
  url.searchParams.append("scope", "openid email");
  url.searchParams.append("nonce", nonce);

  window.location = url.href;
}

export async function validateLogin() {
  const params = new URLSearchParams(window.location.hash.substring(1));
  return params.get("id_token");
}
